export const sizes = {
    phone: 420,
    tablet: 768,
    desktop: 992,
    giant: 1170
  };

  export const media = {
    phone: `@media (max-width: ${sizes.phone}px)`,
    tablet: `@media (max-width: ${sizes.tablet}px)`,
    desktop: `@media (max-width: ${sizes.desktop}px)`,
    giant: `@media (max-width: ${sizes.giant}px)`,
  }

